<!--
  -  TTTech nerve-management-system
  -  Copyright(c) 2021. TTTech Industrial Automation AG.
  -
  -  ALL RIGHTS RESERVED.
  -
  -  Usage of this software, including source code, netlists, documentation,
  -  is subject to restrictions and conditions of the applicable license
  -  agreement with TTTech Industrial Automation AG or its affiliates.
  -
  -  All trademarks used are the property of their respective owners.
  -
  -  TTTech Industrial Automation AG and its affiliates do not assume any liability
  -  arising out of the application or use of any product described or shown
  -  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
  -  make changes, at any time, in order to improve reliability, function or
  -  design.
  -
  -  Contact Information:
  -  support@tttech-industrial.com
  -
  -  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
  -
  -->

<template>
  <NerveDialog v-model="dialogState" scrollable max-width="500" @keydown.enter="confirm()">
    <v-card id="iiotDeployInfoDialogCard" class="deploy-info-dialog d-flex flex-column">
      <v-card-title class="text-center">
        {{ $t(utilsStore.deployInfoDialogParams.title) }}
        <br />
        <v-tooltip right max-width="400">
          <template #activator="{ on, attrs }">
            <div v-bind="attrs" class="mx-2 text-truncate" v-on="on">
              {{ utilsStore.deployInfoDialogParams.serialNumbers }}
            </div>
          </template>
          <span>{{ utilsStore.deployInfoDialogParams.serialNumbers }}</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text v-if="utilsStore.deployInfoDialogParams.subTitle" class="flex-grow-1 text-center text-grey-darken-1">
        {{ $t(utilsStore.deployInfoDialogParams.subTitle) }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <NerveButton
          id="iiotDeployInfoDialogOkButton"
          :text="$t('dialog.ok')"
          type-of-btn="action"
          size="normal"
          class="my-0"
          :disabled="isConfirming"
          @click-event="confirm()"
        />
      </v-card-actions>
    </v-card>
  </NerveDialog>
</template>

<script setup>
import { computed } from 'vue';
import { NerveButton, NerveDialog } from '@nerve/ui-components';
import useUtilsStore from '@/store/modules/pinia/utils/_api_request_handler';
import useSingleFlight from '@/composables/useSingleFlight';

/* 
  Store 
*/
const utilsStore = useUtilsStore();

/*
  Computed
*/
const dialogState = computed({
  get() {
    return utilsStore.deployInfoDialog;
  },
  set() {
    confirm();
  },
});

/*
  Methods
*/
const { run: confirm, isPending: isConfirming } = useSingleFlight(async () => {
  if (utilsStore.deployInfoDialogParams.callback) {
    await utilsStore.deployInfoDialogParams.callback();
  }
  utilsStore.closeDeployInfo();
});
</script>
<style lang="scss" scoped>
.deploy-info-dialog {
  max-height: 460px !important;
  min-height: 360px !important;
}
</style>
